import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

/**
 * Full-screen blocking overlay shown during async operations.
 * Covers the entire parent (position:absolute fill) and absorbs all pointer events
 * so nothing beneath is clickable while it is visible.
 */
function BusyOverlay({ open, message }) {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.55)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'all',
        userSelect: 'none',
      }}
      // Swallow every mouse/touch event so nothing beneath fires
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <Box
        sx={{
          backgroundColor: 'rgba(20, 20, 20, 0.92)',
          borderRadius: 2,
          padding: '24px 40px',
          minWidth: 280,
          textAlign: 'center',
          boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
        }}
      >
        <Typography
          variant="body1"
          sx={{ color: '#fff', fontWeight: 600, mb: 2 }}
        >
          {message || 'Please wait…'}
        </Typography>
        <LinearProgress
          sx={{
            height: 6,
            borderRadius: 3,
            backgroundColor: 'rgba(255,255,255,0.15)',
            '& .MuiLinearProgress-bar': {
              borderRadius: 3,
              background: 'linear-gradient(90deg, #008CD7, #00C9FF)',
            },
          }}
        />
      </Box>
    </Box>
  );
}

export default React.memo(BusyOverlay);
